import React from 'react';
import Link from 'redux-first-router-link';

import { LocaleString } from '@biw/intl';

import './footer.scss';

interface Props {
    showLinks: boolean;
}

const Footer = ({ showLinks }: Props) => (
    <footer className="site-footer">
        <div className="content-container">
            <nav className="footer-menu" role="navigation">>
                { showLinks &&
                    <div className="links" role="menu">
                        <Link to="/faq" role="menuitem" className="foot-link" data-sel="footer-faq">
                            <LocaleString code="footer.faqLabel" />
                        </Link>
                        <Link to="/privacy" role="menuitem" className="foot-link" data-sel="footer-privacy">
                            <LocaleString code="footer.privacyPolicyLabel" />
                        </Link>
                        <Link to="/contact" role="menuitem" className="foot-link" data-sel="footer-contact">
                            <LocaleString code="footer.contactLabel" />
                        </Link>
                    </div>
                }
                <div className="copyright foot-link"><LocaleString code="footer.copyright" /></div>
            </nav>
        </div>
    </footer>
);

export default Footer;
